/**
 * LoadingModal
 *
 * Lightweight centered modal with spinner and message for async operations.
 */
import React from 'react';
import { Loading } from '../feedback/loading';

export function LoadingModal({ 
  isOpen, 
  message = 'Loading...',
  size = 'large'
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-0">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/30 backdrop-blur-sm transition-opacity" />

      {/* Modal Content */}
      <div className="relative transform overflow-hidden rounded-lg bg-white/90 dark:bg-gray-900/90 shadow-xl transition-all px-8 py-6">
        <div className="flex flex-col items-center justify-center space-y-4">
          <Loading size={size} />
          <p className="text-sm font-medium text-gray-900 dark:text-white">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
} 